module.exports = __webpack_public_path__ + "static/assets/e9e50de0415c754dfd9773c1ecb76a4b.svg";